export default __webpack_public_path__ + "static/media/zone_map_1.f6cc2c46.png";